module.exports = __webpack_public_path__ + "img/light-bulb.62785ae8.svg";